import "core-js/modules/es.number.constructor.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "curriculum-panel"
};
var _hoisted_2 = {
  class: "hover-list"
};
var _hoisted_3 = {
  class: "hover-title"
};
var _hoisted_4 = {
  class: "lesson-list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "lesson-title"
};
var _hoisted_7 = {
  class: "lesson-name"
};
var _hoisted_8 = {
  class: "lesson-progress"
};
var _hoisted_9 = {
  class: "main"
};
var _hoisted_10 = ["src"];
import SideBar from '../common/SideBar';
import Empty from '../common/Empty';
import LessonCatalog from './LessonCatalog';

/* 工具 */
import { ref, reactive, inject, nextTick, onMounted, onBeforeUnmount } from 'vue';
import { operationRecord } from '../common/common';
import { LEFT_BAR_MAP } from '../../const';
import { getStore } from '@/util/store';

/* api */
import { getLessonList, saveLessonVideoProgress } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'index',
  setup: function setup(__props) {
    /* 组件 */
    var discussId = inject('discussId');
    var userInfo = getStore({
      name: 'userInfo'
    });
    var state = reactive({
      dialogShow: false,
      catalogList: [],
      lessonUrl: '',
      // 当前播放视频url
      onlineCourseId: '' // 当前播放课程id
    });
    var videoRef = ref();

    /* 事件 */
    // 侧边栏点击
    var sideBarChange = function sideBarChange(item) {
      if (item.click === 'lessonAdd') {
        state.dialogShow = true;
      }
    };

    // 查询第一个有视频的数据
    var findFirstVideo = function findFirstVideo() {
      var res = null;
      for (var i = 0; i < state.catalogList.length; i++) {
        var _item$children;
        var item = state.catalogList[i];
        if ((_item$children = item.children) !== null && _item$children !== void 0 && _item$children.length) {
          res = item.children[0];
          break;
        }
      }
      return res;
    };
    var getList = function getList() {
      getLessonList(discussId.value, userInfo.id).then(function (res) {
        if (res.data.code === 0) {
          state.catalogList = res.data.data || [];
          var first = findFirstVideo();
          if (first) {
            if (state.lessonUrl) return;
            state.lessonUrl = first === null || first === void 0 ? void 0 : first.url;
            state.onlineCourseId = first === null || first === void 0 ? void 0 : first.id;
            operationRecord(discussId.value, '查看课程');
            nextTick(function () {
              videoRef.value && (videoRef.value.currentTime = Number(first === null || first === void 0 ? void 0 : first.watchDuration));
            });
          } else {
            state.lessonUrl = '';
            state.onlineCourseId = '';
          }
        }
      });
    };

    // 记录视频进度
    var saveProgress = function saveProgress() {
      var _videoRef$value;
      if (!state.onlineCourseId) return;
      saveLessonVideoProgress({
        discussId: discussId.value,
        onlineCourseId: state.onlineCourseId,
        userId: userInfo.id,
        watchDuration: (_videoRef$value = videoRef.value) === null || _videoRef$value === void 0 ? void 0 : _videoRef$value.currentTime
      });
    };
    var urlChange = function urlChange(item) {
      if (state.onlineCourseId === item.id) return;
      operationRecord(discussId.value, '查看课程');
      saveProgress();
      state.lessonUrl = item.url;
      state.onlineCourseId = item.id;
      nextTick(function () {
        videoRef.value && (videoRef.value.currentTime = Number(item.watchDuration));
      });
    };

    /* 钩子 */
    onMounted(function () {
      getList();
    });
    onBeforeUnmount(function () {
      saveProgress();
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(SideBar), {
        barList: _unref(LEFT_BAR_MAP)['curriculum'],
        onTabChange: sideBarChange,
        onHoverEnter: getList
      }, {
        hoverList: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.catalogList, function (catalog) {
            return _openBlock(), _createElementBlock("div", {
              key: catalog.id,
              class: "hover-item"
            }, [_createElementVNode("span", _hoisted_3, _toDisplayString(catalog.title), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catalog.children || [], function (lesson) {
              return _openBlock(), _createElementBlock("div", {
                key: lesson.id,
                class: "lesson-item",
                onClick: function onClick($event) {
                  return urlChange(lesson);
                }
              }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_svg_icon, {
                name: "video-play"
              }), _createElementVNode("span", _hoisted_7, _toDisplayString(lesson.title), 1)]), _createElementVNode("span", _hoisted_8, [_cache[1] || (_cache[1] = _createTextVNode(" 已播放 ", -1)), _createElementVNode("i", null, _toDisplayString("".concat(lesson.rate, "%")), 1)])], 8, _hoisted_5);
            }), 128))])]);
          }), 128))])];
        }),
        _: 1
      }, 8, ["barList"]), _createElementVNode("div", _hoisted_9, [state.lessonUrl ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        src: state.lessonUrl,
        controls: "",
        ref_key: "videoRef",
        ref: videoRef
      }, null, 8, _hoisted_10)) : (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        name: "curriculum"
      }))]), _createVNode(_component_t_dialog, {
        visible: state.dialogShow,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return state.dialogShow = $event;
        }),
        header: "添加课程",
        width: "480px",
        placement: "center",
        "confirm-btn": null,
        "cancel-btn": {
          content: '确认',
          theme: 'primary'
        }
      }, {
        default: _withCtx(function () {
          return [state.dialogShow ? (_openBlock(), _createBlock(_unref(LessonCatalog), {
            key: 0,
            onChange: getList
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};